import { ADD_USER } from './gql/addUser';
import { UPDATE_USER } from './gql/update.user';
export const updateUserQuery = (gqlInstance, userPayload) => {
    return gqlInstance
        .getClient('graphqlClient')
        .mutate({
        mutation: UPDATE_USER,
        variables: {
            user: userPayload,
        },
    })
        .then((response) => {
        return response.data.updateUser.user;
    });
};
export const addUserQuery = (gqlInstance, userPayload) => {
    return gqlInstance
        .getClient('graphqlClient')
        .mutate({
        mutation: ADD_USER,
        variables: {
            user: userPayload,
        },
    })
        .then((response) => {
        return response.data.addUser.user;
    });
};
//# sourceMappingURL=user.mutations.js.map